import classNames from 'classnames';
import React from 'react';
import css from './CheckoutPage.module.css';
import { FormattedMessage } from 'react-intl';
import { formatMoney } from '../../util/currency';
import { intlShape } from '../../util/reactIntl';
import { ImageVideoPreview } from '../../components';
import { ReactComponent as BuyerProtectionIcon } from '../../assets/svg/buyer-protection.svg';

const cardRenderSizes = isMapVariant => {
  if (isMapVariant) {
    // Panel width relative to the viewport
    const panelMediumWidth = 50;
    const panelLargeWidth = 62.5;
    return [
      '(max-width: 767px) 100vw',
      `(max-width: 1023px) ${panelMediumWidth}vw`,
      `(max-width: 1920px) ${panelLargeWidth / 2}vw`,
      `${panelLargeWidth / 3}vw`,
    ].join(', ');
  } else {
    // Panel width relative to the viewport
    const panelMediumWidth = 50;
    const panelLargeWidth = 62.5;
    return [
      '(max-width: 549px) 100vw',
      '(max-width: 767px) 50vw',
      `(max-width: 1439px) 26vw`,
      `(max-width: 1920px) 18vw`,
      `14vw`,
    ].join(', ');
  }
};

/**
 *
 * @param {object} props
 * @param {Array<object>} props.listings
 * @param {string} [props.sliderRootClassName]
 * @param {intlShape} props.intl
 * @param {object} props.config
 * @returns
 */
function CustomSlideCard(props) {
  const { listings, sliderRootClassName, intl, config } = props;
  const rootClass = classNames(css.sliderRootContainer, sliderRootClassName);
  const renderSizes = cardRenderSizes(false);
  return (
    <div className={rootClass}>
      {listings.map(listing => {
        const {
          attributes: {
            title,
            price: p,
            publicData: { selectedQty, isOutOfStock, ...rest },
          },
          author: {
            attributes: {
              profile: {
                publicData: { profileUrl, rawProfileUrl },
              },
            },
          },
        } = listing;
        const sizeKey = Object.keys(rest).find(key => /^.*(size).*$/i.test(key));
        const sizeValue = rest[sizeKey] || null;

        const price = formatMoney(intl, p);
        const storeName = (
          <span className={css.cardOptionLabel}>{rawProfileUrl || profileUrl}</span>
        );
        const listingPrice = <span className={css.cardOptionLabel}>{price}</span>;
        const listingSize = sizeValue ? (
          <span className={css.cardOptionLabel}>
            {config.customListingField?.[sizeKey]?.[sizeValue]?.label ?? 'Unknown'}
          </span>
        ) : (
          <span className={css.cardOptionLabel}>Unknown</span>
        );
        const soldOutText = isOutOfStock ? (
          <span className={css.soldOutText}>&nbsp;({intl.formatMessage({ id: 'soldOut' })})</span>
        ) : null;
        const qtyLabel = (
          <span className={css.cardOptionLabel}>
            {selectedQty}
            {soldOutText}
          </span>
        );

        return (
          <div key={listing.id.uuid} className={css.cardRoot}>
            <ImageVideoPreview
              listing={listing}
              config={config}
              renderSizes={renderSizes}
              className={css.imageVideoContainer}
              imageClassName={css.imageRoot}
              videoPlayerClassName={css.videoPlayer}
            />
            <div className={css.cardOptionContainer}>
              <span className={css.cardTitle}>{title}</span>
              <p className={css.cardOption}>
                <FormattedMessage id="customSliderCard.storeName" values={{ storeName }} />
                <FormattedMessage id="customSliderCard.price" values={{ price: listingPrice }} />
                <FormattedMessage id="customSliderCard.sizeName" values={{ size: listingSize }} />
                <FormattedMessage id="customSliderCard.qty" values={{ qty: qtyLabel }} />
                <span className={css.buyerProtectionMobile}>
                  <span className={css.buyerProtectionTitleRow}>
                    <BuyerProtectionIcon className={css.buyerProtectionIcon} />
                    <span className={css.buyerProtectionTitle}>
                      {intl.formatMessage({ id: 'CustomslideCard.buyerProtection' })}
                    </span>
                  </span>
                  <span className={css.buyerProtectionText}>
                    {intl.formatMessage({ id: 'CustomslideCard.buyerProtectionText' })}
                  </span>
                </span>
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default CustomSlideCard;
